import React from 'react';
import styles from './WeightProgress.module.css';

const lifts = [
  { key: 'squat', label: 'Squat', day1Key: 'squat_day1', currentKey: 'squat_weight' },
  { key: 'bench', label: 'Bench', day1Key: 'bench_day1', currentKey: 'bench_weight' },
  { key: 'press', label: 'Press', day1Key: 'press_day1', currentKey: 'press_weight' },
  { key: 'deadlift', label: 'Deadlift', day1Key: 'deadlift_day1', currentKey: 'deadlift_weight' },
];

const WeightProgress = ({ logbook }) => (
  <div className={styles.WeightProgress}>
    <h3 className={styles.Title}>Starting vs Current Weights</h3>
    {lifts.map(lift => {
      const start = logbook[lift.day1Key];
      const current = logbook[lift.currentKey];
      const gain = start != null && current != null ? current - start : null;

      return (
        <div key={lift.key} className={styles.Row}>
          <span className={styles.LiftName}>{lift.label}</span>
          <div className={styles.Weights}>
            <span>{start != null ? start : '-'}</span>
            <span className={styles.Arrow}>&rarr;</span>
            <span className={styles.Current}>{current != null ? current : '-'}</span>
          </div>
          <span className={styles.Gain}>
            {gain != null ? `+${gain} lbs` : ''}
          </span>
        </div>
      );
    })}
  </div>
);

export default WeightProgress;
